export default [
  {
    text: 'posSync.table.status',
    value: 'status',
    type: 'slot',
  },
  {
    text: 'posSync.table.venue',
    value: 'venue',
    type: 'slot',
  },
  {
    text: 'posSync.table.user',
    value: 'user',
    type: 'slot',
  },
  {
    text: 'posSync.table.syncMode',
    value: 'syncMode',
  },
  {
    text: 'posSync.table.errorMessage',
    value: 'errorMessage',
  },
  {
    text: 'posSync.table.createdAt',
    value: 'createdAt',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
  },
  {
    text: 'posSync.table.startedAt',
    value: 'startedAt',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
  },
  {
    text: 'posSync.table.finishedAt',
    value: 'finishedAt',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
  },
  {
    text: 'posSync.table.failedAt',
    value: 'failedAt',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
  },
];
